import { CreditDto, SlotCode } from '@mkp/shared/models';

/**
 * Determines if a credit is a slot credit
 * @param credit The credit to check
 * @returns True if the credit is a slot credit, false otherwise
 */
export const isCreditSlot = (credit: CreditDto): boolean => {
  const productType = credit.product.type;
  return Object.values(SlotCode).includes(productType as unknown as SlotCode);
};
